var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(-1045 -325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 30,
    height: 30,
    transform: "translate(1045 325)",
    fill: "#13bcd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Base-2",
    "data-name": "Base",
    width: 24,
    height: 24,
    transform: "translate(1048 328)",
    fill: "#13bcd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "dog-tag",
    transform: "translate(1048 328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M15.6,2.859l-2.111,3.1A1.758,1.758,0,1,1,12,5.133a1.768,1.768,0,0,1,.327.031L14.272,2.31a7.746,7.746,0,0,0-4.545,0l-1.365-2A.7.7,0,1,0,7.2,1.1l1.2,1.76A7.741,7.741,0,0,0,4.266,9.7v6.562a7.734,7.734,0,1,0,15.469,0V9.7A7.741,7.741,0,0,0,15.6,2.859Zm-.318,15.75H8.719a.7.7,0,0,1,0-1.406h6.562a.7.7,0,0,1,0,1.406Zm0-2.812H8.719a.7.7,0,0,1,0-1.406h6.562a.7.7,0,0,1,0,1.406Zm0-2.812H8.719a.7.7,0,0,1,0-1.406h6.562a.7.7,0,0,1,0,1.406Z",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    d: "M16.8,1.1A.7.7,0,1,0,15.638.307l-1.365,2a7.69,7.69,0,0,1,1.327.55Z",
    fill: "#13bcd4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.60d51f3a85a0498cb57ab1350047c359.svg";
export { ForwardRef as ReactComponent };